import {FileFormURL} from "@/includes/file-form-url";
import Route from "@frontend/services/helpers/url";
import vuexStore from "@frontend/store";
import {MUTATIONS} from "@frontend/store/figma-layers";
import {initFigmaViewer} from "@/includes/fig-parser";
import {EVENTS as PSD_LAYERS_EVENT, psdLayersEventBroker} from "@frontend/group/modules/psd-layers/event-broker";
import {multipleTemplateHandler} from "@frontend/group/modules/psd-layers/helpers";
import TemplateService from "@frontend/services/api/template";
import LayoutService from "@frontend/services/api/layout";
import {
  getGridDataForImportAndCreateStrategy,
  getLayoutInfo, PSD_IMPORT_WARNINGS_KEY
} from "@frontend/group/modules/import-template-from-psd/import-from-psd-new-template";
import {figmaLayersEventBroker} from "@frontend/group/modules/fig-layers/event-broker";
import {getUpdatedDataLayoutTemplatesGrid} from "@frontend/group/modules/get-updated-data-layout-templates-grid";
import {FigStrategy} from "@frontend/group/modules/fig-layers/strategy";

export const IMPORT_AND_CREATE_STRATEGY = 'import-and-create';
export const ACTION_IMPORT_FROM_FIG = 'import-from-fig';
export const ACTION_IMPORT_FROM_PRESELECTED_FIG = 'import-from-preselected-fig';

const MOCK_CONTENT_FOR_GRID = () => $('<div></div>');

function getDataGrid(newTemplates) {
  const previews = window.previews || [];
  const oldTemplates = [];

  previews.forEach(({ template, settings: { instance_id, x, y, w, h } }) => {
    oldTemplates.push({
      id: template.id,
      instanceId: instance_id,
      name: template.name,
      width: template.width,
      height: template.height,
      content: MOCK_CONTENT_FOR_GRID(),
      gridData: { x, y, w, h }
    });
  });

  return getUpdatedDataLayoutTemplatesGrid(oldTemplates, newTemplates);
}

function initImportAndCreateStrategy(postHandler) {
  const { id, customerId } = getLayoutInfo();

  const newTemplatesSettings = [];
  
  vuexStore.commit(`figmaLayers/${MUTATIONS.SET_FLOW}`, FigStrategy.FLOWS.CREATE_TEMPLATES);

  figmaLayersEventBroker.on(
    PSD_LAYERS_EVENT.FILL_TEMPLATE,
    multipleTemplateHandler(async (state) => {
      const width = state.template.width;
      const height = state.template.height;
      let transformSize;

      const gridData = getDataGrid([{
        width: transformSize?.width || width,
        height: transformSize?.height || height
      }]);

      const sourceFile = state?.absoluteFilename?.match(/user-folder\/(\d+)\/user-files/)
        ? state.absoluteFilename
        : null;

      const name = `${state.originalFileName.split('/').pop()} ${state.template.name || ''}`.trim()
      const response = await TemplateService.createTemplate(customerId, id, {
        width,
        height,
        name,
        layers: state.layers,
        gridData: getGridDataForImportAndCreateStrategy(gridData),
        sourceFile: sourceFile,
      });

      const { templateSettings, warnings } = response.data;
      localStorage.setItem(PSD_IMPORT_WARNINGS_KEY, JSON.stringify(warnings));
      newTemplatesSettings.push(templateSettings);

    }, async (options) => {
      if (postHandler) {
        postHandler();
      }

      await LayoutService.updateLayoutSettings(customerId, id, newTemplatesSettings);

      newTemplatesSettings.length = 0;

      if (options.isOpenInBannerBuilder) {
        window.location.href = `${window.location.origin}/banner-builder/manage-assets?layoutId=${window.layoutId}`;
      } else {
        psdLayersEventBroker.fire(PSD_LAYERS_EVENT.CLOSE_AND_RELOAD);
      }
    }),
    true
  );
}


export const importPreselectedFig = async () => {
  const importFromFigDataJSON = localStorage.getItem(ACTION_IMPORT_FROM_PRESELECTED_FIG);

  if (!importFromFigDataJSON) {
    console.error('No FIG data found!');
    return;
  }

  const importFromFigData = JSON.parse(importFromFigDataJSON);

  if (!importFromFigData.files) {
    console.error('No files found!');
    return;
  }

  const files = importFromFigData.files.map(figFile => new FileFormURL(figFile.url, figFile.name, figFile.id));

  const postHandler = () => {
    localStorage.removeItem(ACTION_IMPORT_FROM_PRESELECTED_FIG);
    Route.deleteParam(ACTION_IMPORT_FROM_PRESELECTED_FIG);
  }

  initImportAndCreateStrategy(postHandler);


  initFigmaViewer(files, undefined);
}
